// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"77":"a82f9c98","389":"00bbd3e5","423":"ec762e3a","486":"c0717d22","567":"581ee326","591":"02b9d1f1","788":"2660ca0f","797":"967124c1","851":"bfa60426","950":"44d27f2b"}[chunkId] + ".chunk.js";
};